module.exports = __webpack_public_path__ + "static/media/reject.31f299fb.svg";